import { Box, Heading, Stack } from "@chakra-ui/react";
import { FC } from "react";
import { Control, FieldValues, UseFormWatch } from "react-hook-form";
import { borderRadius, borderStyle } from "../../../../utils/styles/styles";
import FormSelect from "../../../../components/molecule/Select/FormSelect";
import { getPartners } from "../../../../services/TabelasAuxiliares/getPartner";
import { getIndicatorIntegration } from "../../../../services/Indicator/getIndicatorIntegration";
import IndicatorManagementState from "../../components/IndicatorManagementState";
import LabelComponent from "../../../../components/atom/Label/LabelComponent";

interface IndicatorCollectionFormProps {
  errors: any;
  control: Control<any>;
  isDisabled?: boolean;
  watch: UseFormWatch<FieldValues>;
  indicatorState?: {
    id: number;
    name: string;
  };
}

const IndicatorCollectionForm: FC<IndicatorCollectionFormProps> = ({
  errors,
  control,
  isDisabled,
  watch,
  indicatorState = null,
}) => {
  return (
    <Stack spacing={8}>
      <Stack
        spacing={4}
        border={borderStyle}
        borderRadius={borderRadius}
        background="gray.50"
        p={6}
      >
        <Heading as="h3" fontSize="2xl">
          Informações sobre a recolha
        </Heading>
        {indicatorState && (
          <Box>
            <LabelComponent title="Estado" fontWeight="500" fontSize="md" />
            <IndicatorManagementState
              stateValue={indicatorState}
              additionalStyle={{ display: "inline-block" }}
            />
          </Box>
        )}
        <FormSelect
          control={control}
          errors={errors}
          watch={watch}
          fieldName="partnerOption"
          fieldLabel="Parceiro"
          fetchOptions={getPartners}
          isDisabled={isDisabled}
        />
        <FormSelect
          control={control}
          errors={errors}
          watch={watch}
          fieldName="integrationOption"
          fieldLabel="Integração"
          fetchOptions={getIndicatorIntegration}
          isDisabled={isDisabled}
        />
      </Stack>
    </Stack>
  );
};

export default IndicatorCollectionForm;
